import CrossIcon from '@atlaskit/icon/glyph/cross';
import { SerializedStyles } from '@emotion/react';

import { closeModalButtonStyles } from './close-modal-button.styles';
import { useMessages } from '../state';

export const CloseModalButton = ({
  onCloseClick,
  styleOverrides
}: {
  onCloseClick: () => void | Promise<void>;
  styleOverrides?: SerializedStyles;
}) => {
  const [messages] = useMessages();

  return (
    <button
      data-testid="closeModalBtn"
      aria-label={messages.createIssueModalCloseBtn}
      css={[styleOverrides, closeModalButtonStyles]}
      id="createIssueModalCloseBtn"
      onClick={onCloseClick}
    >
      <CrossIcon label="" size="medium" />
    </button>
  );
};
